import api from '@/api'
import globalLoading from '@/functions/globalLoading'
import is from '@/functions/is'
import reset from '@/functions/reset'
import sessionToken from '@/functions/sessionToken'
import store from '@/store'

/**
 *
 * @param {Object} to vue-router to object
 * @param {Object} from vue-router from object
 * @param {Function} next vue-router next function
 */
export default async function (to, from, next) {
  if (sessionToken.get()) {
    globalLoading.start()

    try {
      // Test existing session token for validity
      await api.post('auth/validate/')
    } catch (error) {
      // Handle authentication or unverified error
      if (
        error.response && error.response.data &&
        (
          error.response.data.code === 'authentication_failed' ||
          error.response.data.code === 'unverified'
        )
      ) {
        sessionToken.remove()
        reset.store()
        next({ name: 'login' })
        store.commit('notifications/add', {
          text: 'Bitte melden Sie sich mit Ihrem Konto erneut an.',
          type: 'error'
        })
      }

      globalLoading.error()

      return
    }

    globalLoading.success()

    // Redirect logged in users if they try to access public routes
    if (to.meta.permission && to.meta.permission.public) {
      if (to.params && !to.params.token) {
        return next({ name: 'dashboard' })
      }
    }

    // Force user to select role
    if (!store.state.user.data.selected_role && to.name !== 'select-role') {
      store.commit('notifications/add', {
        text: 'Bitte wählen Sie Ihr Vorhaben aus.'
      })
      return next({ name: 'select-role' })
    }

    // Force users to fill in personal data
    if (!store.state.user.data.completed_registration && to.name !== 'dashboard-personal-data') {
      store.commit('notifications/add', {
        text: 'Bitte ergänzen Sie Ihre persönlichen Daten, damit Sie die Seite benutzen können.'
      })
      return next({ name: 'dashboard-personal-data' })
    }

    // Continue to route if user meets permissions
    if (!to.meta.permission || !to.meta.permission.group || is(to.meta.permission.group)) {
      return next()
    }

    store.commit('notifications/add', {
      type: 'error',
      text: 'Leider reichen Ihre Berechtigungen nicht aus, um auf diese Seite zuzugreifen.'
    })

    // Fallback to Dashboard
    next({ name: 'dashboard' })
  } else if (to.meta.permission && to.meta.permission.public) {
    // Allow public routes for users which aren't logged in
    next()
  } else {
    // Redirect to login page if user isn't logged
    // and isn't accessing public route
    next({ name: 'login' })
  }
}
